import React from 'react';
import { Tooltip } from 'antd';
import { getMetricDisplayName } from '@utils/metrics';
import { isAppModule } from '@utils/constants';

function TableHeaderCell({ column }) {
  const displayName = getMetricDisplayName({ metricKey: column.key });
  return (
    <Tooltip title={isAppModule ? column.title : displayName}>
      <span>{column.title}</span>
    </Tooltip>
  );
}

export default TableHeaderCell;
